import {
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { thStyle } from "../../helpers/constants";
import RewardListRow from "./rewardListRow";

interface Props {
  rewards: Reward[];
  onSelect?: (id: string, state: "add" | "remove") => void;
}

export default function RewardList({ rewards, onSelect }: Props) {
  return (
    <CTable responsive hover align="middle" className="mb-0">
      <CTableHead>
        <CTableRow>
          <CTableHeaderCell style={thStyle}></CTableHeaderCell>
          <CTableHeaderCell style={thStyle}>Titre</CTableHeaderCell>
          <CTableHeaderCell style={thStyle}>Type</CTableHeaderCell>
          <CTableHeaderCell style={thStyle}>Points requis</CTableHeaderCell>
          <CTableHeaderCell style={thStyle}>Actif</CTableHeaderCell>
          <CTableHeaderCell style={thStyle}>Réutilisable</CTableHeaderCell>
          <CTableHeaderCell style={thStyle}>Mis en avant</CTableHeaderCell>
          <CTableHeaderCell style={{ ...thStyle, textAlign: "right" }}>
            Actions
          </CTableHeaderCell>
        </CTableRow>
      </CTableHead>

      <CTableBody>
        {rewards?.map((reward) => (
          <RewardListRow key={reward.id} reward={reward} onSelect={onSelect} />
        ))}
      </CTableBody>
    </CTable>
  );
}
